import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cardCategoriesList"
};
const _hoisted_2 = { class: "cardHeading" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "cardHeading-content" };
const _hoisted_5 = { class: "cardTitle" };
const _hoisted_6 = ["href", "innerHTML"];
const _hoisted_7 = { class: "cardMeta" };
const _hoisted_8 = {
    key: 0,
    class: "cardDate"
};
const _hoisted_9 = ["innerHTML"];
import { ThemeButton } from "../../index";
import { computed } from 'vue';
import { niceDateFromISO8601 } from '../../../shared';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Article',
    props: {
        document: {}
    },
    setup(__props) {
        const props = __props;
        const elapsedTime = computed(() => niceDateFromISO8601(props.document.published_at));
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["siteSearch-hit", {
                        'is--external': _ctx.document.external_source,
                        'is--restricted': (_a = _ctx.document.external_source) === null || _a === void 0 ? void 0 : _a.browsing_restrictions.length,
                        'with--image': _ctx.document.thumbnail_url,
                    }]),
                "data-hit": "article"
            }, [
                (_ctx.document.categories)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.document.categories, (category) => {
                            return (_openBlock(), _createBlock(_unref(ThemeButton), {
                                type: "link",
                                title: category.label,
                                href: category.url,
                                variation: "chip",
                                size: "tiny",
                                color: "light"
                            }, null, 8, ["title", "href"]));
                        }), 256))
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.document.thumbnail_url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "cardHeading-thumbnail",
                            src: _ctx.document.thumbnail_url,
                            alt: ""
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h4", _hoisted_5, [
                            _createElementVNode("a", {
                                href: _ctx.document.url,
                                innerHTML: ((_b = _ctx.document._formatted) === null || _b === void 0 ? void 0 : _b.title) || _ctx.document.title
                            }, null, 8, _hoisted_6)
                        ]),
                        _createElementVNode("p", _hoisted_7, [
                            (_ctx.document.published_at)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(elapsedTime.value), 1))
                                : _createCommentVNode("", true),
                            (_ctx.document.external_source)
                                ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                                    key: 1,
                                    type: "link",
                                    fill: "text",
                                    size: "small",
                                    icon: "external-resource",
                                    href: _ctx.document.url,
                                    title: _ctx.document.external_source.label,
                                    color: _ctx.document.external_source.browsing_restrictions.length ? 'quart' : 'gray'
                                }, null, 8, ["href", "title", "color"]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                _createElementVNode("p", {
                    class: "cardExcerpt",
                    innerHTML: ((_c = _ctx.document._formatted) === null || _c === void 0 ? void 0 : _c.excerpt) || _ctx.document.excerpt
                }, null, 8, _hoisted_9)
            ], 2));
        };
    }
});
